import { ReactNode } from 'react';

import { Outlet } from 'react-router-dom';

import { Box, Stack } from '@mui/material';

import { RecordingCredits } from '@/features/recording/recordingCredits';

import { RecordingHeader } from './ui/Header';
import { RecordingSidebar, RecordingToggleSidebar } from './ui/Sidebar';

type Props = {
  children?: ReactNode;
  isAuthenticated?: boolean;
};

export const RecordingLayout = ({ children, isAuthenticated = true }: Props) => (
  <Stack direction="row" sx={{ height: '100vh' }}>
    <RecordingSidebar isAuthenticated={isAuthenticated} />
    <Stack flex={1} minWidth={0}>
      <RecordingHeader
        creditsSlot={isAuthenticated ? <RecordingCredits /> : null}
        sidebarSlot={<RecordingToggleSidebar isAuthenticated={isAuthenticated} />}
      />
      <Box sx={{ flex: 1, overflow: 'auto' }}>{children ?? <Outlet />}</Box>
    </Stack>
  </Stack>
);
